import React from "react";

export const OrdersPageSkeleton: React.FC<{ count?: number }> = ({ count = 3 }) => {
  return (
    <div className="p-3">
      {/* Заголовок */}
      <div className="h-5 w-56 rounded bg-slate-200 animate-pulse" />

      {/* Стат-виджеты */}
      <div className="mt-3 grid grid-cols-3 gap-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="rounded-2xl bg-white p-3 shadow-sm">
            <div className="mx-auto h-7 w-10 rounded bg-slate-200 animate-pulse" />
            <div className="mt-2 mx-auto h-3 w-20 rounded bg-slate-200 animate-pulse" />
          </div>
        ))}
      </div>

      {/* Список заказов */}
      <div className="mt-4 space-y-3">
        {Array.from({ length: count }).map((_, i) => (
          <OrderCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
};

const OrderCardSkeleton: React.FC = () => {
  return (
    <div className="rounded-2xl bg-white p-3 shadow-sm">
      {/* top row: #id + time + badges */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-4 w-12 rounded bg-slate-200 animate-pulse" />
          <div className="h-3 w-10 rounded bg-slate-200 animate-pulse" />
        </div>

        <div className="flex gap-2">
          <div className="h-6 w-20 rounded-xl bg-slate-200 animate-pulse" />
          <div className="h-6 w-16 rounded-xl bg-slate-200 animate-pulse" />
        </div>
      </div>

      {/* user row */}
      <div className="mt-3 space-y-2">
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 rounded bg-slate-200 animate-pulse" />
          <div className="h-3 w-28 rounded bg-slate-200 animate-pulse" />
        </div>

        <div className="flex items-center gap-2">
          <div className="h-3 w-3 rounded bg-slate-200 animate-pulse" />
          <div className="h-3 w-32 rounded bg-slate-200 animate-pulse" />
        </div>

        <div className="flex items-center gap-2">
          <div className="h-3 w-3 rounded bg-slate-200 animate-pulse" />
          <div className="h-3 w-14 rounded bg-slate-200 animate-pulse" />
        </div>
      </div>

      {/* order items box */}
      <div className="mt-3 rounded-xl bg-slate-100 p-3">
        <div className="h-3 w-24 rounded bg-slate-200 animate-pulse" />
        <div className="mt-2 space-y-2">
          <div className="h-3 w-56 rounded bg-slate-200 animate-pulse" />
          <div className="h-3 w-44 rounded bg-slate-200 animate-pulse" />
        </div>
      </div>

      {/* buttons row */}
      <div className="mt-3 flex items-center gap-2">
        <div className="h-10 flex-1 rounded-xl bg-slate-200 animate-pulse" />
        <div className="h-10 flex-1 rounded-xl bg-slate-200 animate-pulse" />
        <div className="h-10 w-10 rounded-xl bg-slate-200 animate-pulse" />
      </div>

      {/* bottom hint */}
      <div className="mt-3 flex items-center gap-2">
        <div className="h-3 w-3 rounded bg-slate-200 animate-pulse" />
        <div className="h-3 w-52 rounded bg-slate-200 animate-pulse" />
      </div>
    </div>
  );
};
